// NotificationModal.js
import React, { useState } from 'react';
import './NotificationModal.css';

const NotificationModal = ({ isOpen, onClose, onSubmit, username, device_token, loungeID, loungeName, totalGuests, phoneNumber, communication }) => {
  // Calculate 5 minutes from now in ISO format for datetime-local input
  const getFiveMinutesFromNow = () => {
    const now = new Date();
    now.setMinutes(now.getMinutes() + 5);
    // Format for datetime-local input (YYYY-MM-DDTHH:mm)
    return now.toISOString().slice(0, 16);
  };

  const [formData, setFormData] = useState({
    Title: 'Lounge is Available!',
    Image: 'https://loungeimage.blob.core.windows.net/loungeatlas-icons/WAILIST BUTTON.png',
    Body: `Hi, "${loungeName}" is available for your visit! Please confirm/decline your presence within 5 minutes using Notification Center of Lounge Atlas.`,
    Device_Token: device_token,
    Expiration: getFiveMinutesFromNow(),
    LoungeID: loungeID, 
    LoungeName: loungeName,
    TotalGuests: totalGuests
  });

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

const handleSubmit = (e) => {
  e.preventDefault();
  
  // Take the local datetime value and treat it as UTC by just adding :00Z
  // This prevents timezone conversion
  const expirationUTC = formData.Expiration + ':00Z';
  
  onSubmit({
    ...formData,
    Expiration: expirationUTC
  });
  
  // Reset form with default values
  setFormData({
    Title: 'Lounge is Available!',
    Image: 'https://loungeimage.blob.core.windows.net/loungeatlas-icons/WAILIST BUTTON.png',
    Body: `Hi, "${loungeName}" is available for your visit! Please confirm/decline your presence within 5 minutes using Notification Center of Lounge Atlas.`,
    Device_Token: '',
    Expiration: getFiveMinutesFromNow()
  });
}; 
 
  // Reset form data when modal opens with fresh default values
  React.useEffect(() => {
    if (isOpen) {
      setFormData({
        Title: 'Lounge is Available!',
        Image: 'https://loungeimage.blob.core.windows.net/loungeatlas-icons/WAILIST BUTTON.png',
        Body: `Hi, "${loungeName}" is available for your visit! Please confirm/decline your presence within 5 minutes using Notification Center of Lounge Atlas.`,
        Device_Token: '',
        Expiration: getFiveMinutesFromNow()
      });
    }
  }, [isOpen]);

  if (!isOpen) return null;
return (
  <div className="modal-overlay" onClick={onClose}>
    <div className="modal-content" onClick={(e) => e.stopPropagation()}>
      <div className="modal-header">
        <div className="header-content">
          <h3>Send Notification</h3>
        </div>
        <button className="modal-close" onClick={onClose}>&times;</button>
      </div>

      <div className="user-info-card">
        <div className="info-row">
          <div className="info-item">
            <span className="info-label">User</span>
            <span className="info-value">{username}</span>
          </div>
          <div className="info-item">
            <span className="info-label">Guests</span>
            <span className="info-value badge">{totalGuests}</span>
          </div>
        </div>
        <div className="info-row">
          <div className="info-item">
            <span className="info-label">Lounge</span>
            <span className="info-value">{loungeName} <span className="lounge-id">#{loungeID}</span></span>
          </div>
          <div className="info-item">
            <span className="info-label">Preferred Contact</span>
            <span className="info-value"> {communication}</span>
          </div>
        </div>
      </div>

      <form onSubmit={handleSubmit}>
        <div className="form-body">
          <div className="form-group">
            <label htmlFor="Title">
              Title <span className="required">*</span>
            </label>
            <input
              type="text"
              id="Title"
              name="Title"
              value={formData.Title}
              onChange={handleChange}
              required
              placeholder="e.g., Your table is ready!"
            />
          </div>

          <div className="form-group">
            <label htmlFor="Body">
              Message <span className="required">*</span>
            </label>
            <textarea
              id="Body"
              name="Body"
              value={formData.Body}
              onChange={handleChange}
              required
              placeholder="Enter your notification message here..."
              rows="4"
            />
          </div>

          <div className="form-group">
            <label htmlFor="Image">
              Image URL <span className="optional">(optional)</span>
            </label>
            <input
              type="text"
              id="Image"
              name="Image"
              value={formData.Image}
              onChange={handleChange}
              placeholder="https://example.com/image.jpg"
            />
          </div>

          <div className="form-group">
            <label htmlFor="Expiration">
              Expiration (UTC) <span className="optional">(default: 5 min)</span>
            </label>
            <input
              type="datetime-local"
              id="Expiration"
              name="Expiration"
              value={formData.Expiration}
              onChange={handleChange}
            />
          </div>
        </div>

        <div className="modal-footer">
          <button type="button" className="btn-cancel" onClick={onClose}>
            Cancel
          </button>
          <button type="submit" className="btn-submit">
            Send Notification
          </button>
        </div>
      </form>
    </div>
  </div>
);
};

export default NotificationModal;